module.exports = function () {
	$('a[data-track]').forEach(el => {
		el.addEventListener('click', e => {
			const [category, action, label] = el.getAttribute('data-track').split(';');
			ga('send', 'event', category, action, label);
		});
	});
};
